<template>
    <div class="pd-page">
        <div class="pd-page-header">轧辊工厂-MES系统</div>
        <div class="pd-page-body">
            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>企业类型
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>铸造、机加</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户介绍
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>某轧辊公司，专注于生产轧辊产品四十余年，客户遍布世界二十多个国家和地区，已发展成为集自主研发、设计、铸造、热处理、机加工为一体的高新技术企业，主营业务为生产和销售离心铸造和常法铸造的铸铁轧辊、高速钢轧辊、复合铸钢轧辊等30余类轧辊产品。</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>客户痛点
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>铸造环节成本高，原料为含合金钢材，成本差异大，人工配料无法实现原料成本最低。 </li>
                        <li>计划变化频繁，计划排程考虑因素多，人工排程无法实现最优化，导致加工成本高。</li>
                        <li>加工中、待加工产品状态、数量统计不准确，车间查看胡乱，导致实际生产混乱，工作安排不合理，任务协同效率低。</li>
                        <li>产品质量异常线下处理、异常标记不及时，出现问题了，工人可能会继续加工。</li>
                        <li>质量异常处置涉及部门多、需要考量因素多，线下评审导致处置审批周期长，数据不直观，导致各部门间反复沟通，效率低。 </li>
                        <li>质量数据仅备档，无调档。导致质量异常数据对未来生产无参考价值。</li>
                        <li>报废品利用率低，导致废品库存积压，再利用周期长。 </li>
                        <li>图纸传达的时效性差，图纸又会经常变更，导致加工出错概率增大。 </li>
                        <li>生产成本核算以财务月度结算为准，误差大，无法精确到批次和单个产品。 </li>
                        <li>管理层需要每天开早会，各部门汇报进度及问题，领导统筹进行工作安排，管理效率低。</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>解决方案
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>快速应对订单变化：通过系统快速运算，实现计划直观修改、快速重排，提高排程效率</li>
                        <li>改进生产管理：精益生产过程管理，生产数据采集，快速定位生产瓶颈，为生产调度提供执行依据</li>
                        <li>优化图纸管理方式：实现多环节多图纸上传、保留变更履历等，提升图纸变化传递时效性 </li>
                        <li>车间智能终端管理：实现作业指导在线浏览，无需下发纸质单据，实现“无纸化作业” </li>
                        <li>废品智能推荐：将新产品与废品库做参数比对，按匹配度智能推荐报废品进行优先改制</li>
                        <li>优化质检管理业务：质检数据电子化，自动判别质检项次结果，提升信息传递效率 </li>
                        <li>建立质量体系：搭建标准质量体系，基于质量维度管控生产流程，实现双向质量追溯 </li>
                        <li>绩效自动核算：利用PAD派工、执行、报工，结合绩效考核，实现工人工资自动核算</li>
                        <li>设备能耗统计与分析：计算分析能耗水平和能源使用效率，实现能源优化使用 </li>
                        <li>移动终端，协同办公：不同角色不同终端，信息化贯穿整个车间及每个员工</li>
                        <li>现场可视化看板：监控车间生产、质量、设备等状态信息，是监视车间KPI指标的“仪表盘</li>
                        <li>经营管理驾驶舱：图形、图表全维度深度展示，为决策提供有效依据</li>
                    </ul>
                </div>
            </div>

            <div class="pd-page-part">
                <div class="pd-page-part-title">
                    <i class="fa fa-stop"></i>应用价值
                </div>
                <div class="pd-page-part-body">
                    <ul>
                        <li>构建生产计划执行能力：适应客户频繁需求变化，提升按期交付率，优化产品在制周期20%以上</li>
                        <li>全程质量追溯：保证质量稳定，减少返工率15%以上，提高客户满意度 </li>
                        <li>打通生产制造全流程：异常反应及处理效率提升70%以上</li>
                        <li>强化成本控制：减少废品滞留库存，降低生产成本20%以上 </li>
                        <li>无纸化办公：实现数据实时采集、实时共享，节省数据报表统计时间70%以上 </li>
                        <li>全厂资源信息整合：实现数据在全厂范围保持一致，消除数据分歧，提升准确性 </li>
                        <li>建立并提升了移动办公及协调管理能力</li>
                        <li>为公司领导层提供大数据辅助决策，提升决策效率10%以上</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "casePage5"
}
</script>

<style scoped>

</style>
